import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Select from 'react-select'
import { Value } from '@types'

import Icon from './Icon'

interface Props {
  start: number
  end: number
  limit?: number
  count: number
  prevPressed?: () => void
  nextPressed?: () => void
  onLimitChange?: (limit: number) => void
  className?: any
}

const DEFAULT_LIMIT = 10

export default class PagingController extends Component<Props> {
  limits: Value<number>[] = [10, 20, 50, 100, 200].map((value) => ({ value, label: String(value) }))

  render() {
    const { start, end, limit, count, nextPressed, prevPressed, onLimitChange, className } = this.props
    const value = limit ? { value: limit, label: `${limit}` } : undefined
    return (
      <div className={`sq-pagination${className ? ` ${className}` : ''}`}>
        <div className="sq-pagination__summary">
          {onLimitChange && (
            <div className="sq-pagination__limit">
              <Select
                aria-label="Risultati per pagina"
                value={value}
                onChange={(selected) => onLimitChange(selected ? selected.value : DEFAULT_LIMIT)}
                options={this.limits}
              />
            </div>
          )}
          <span>{`${start}-${end} di ${count}`}</span>
        </div>
        <div className="sq-pagination__buttons">
          <Button aria-label="Pagina precedente" className="sq-pagination__button" variant="light" onClick={prevPressed}>
            <Icon name="back" size={18} />
          </Button>
          <Button aria-label="Pagina successiva" className="sq-pagination__button" variant="light" onClick={nextPressed}>
            <Icon name="forward" size={18} />
          </Button>
        </div>
      </div>
    )
  }
}
